import { createFileRoute } from "@tanstack/react-router";
import { SERVICE_BY_SLUG } from "@/lib/services";
import { ServicePageTemplate } from "@/components/site/ServicePageTemplate";
import { faqSchema, serviceSchema, breadcrumbSchema } from "@/components/site/SchemaJsonLd";

const service = SERVICE_BY_SLUG["sewer-line-repair-and-replacement-phoenix-az"];

export const Route = createFileRoute("/sewer-line-repair-and-replacement-phoenix-az")({
  head: () => ({
    meta: [
      { title: service.title },
      { name: "description", content: service.description },
      { property: "og:title", content: service.title },
      { property: "og:description", content: service.description },
      { property: "og:url", content: "https://www.phoenixplumbing.co/sewer-line-repair-and-replacement-phoenix-az" },
      { name: "twitter:title", content: service.title },
      { name: "twitter:description", content: service.description },
    ],
    links: [{ rel: "canonical", href: "https://www.phoenixplumbing.co/sewer-line-repair-and-replacement-phoenix-az" }],
    scripts: [
      { type: "application/ld+json", children: JSON.stringify(serviceSchema(service.name, service.description)) },
      { type: "application/ld+json", children: JSON.stringify(faqSchema(service.faqs)) },
      { type: "application/ld+json", children: JSON.stringify(breadcrumbSchema([{ name: "Home", url: "/" }, { name: "Sewer Line Repair & Replacement", url: "/sewer-line-repair-and-replacement-phoenix-az" }])) },
    ],
  }),
  component: () => <ServicePageTemplate service={service} />,
});
